import React, { useState } from "react";

const TTMatrix = () => {
  // List of teachers with their period limits
  const teachers = [
    { name: "Ardina M Marak", limit: 5 },
    { name: "Balcina K Sangma", limit: 5 },
    { name: "Kripalin N Marak", limit: 5 },
    { name: "Chesry R Marak", limit: 5 },
    { name: "Maynisha D Shira", limit: 6 },
    { name: "Robilla Ch Momin", limit: 5 },
    { name: "Titush Ch Sangma", limit: 5 },
    { name: "Reshmita Hajong", limit: 5 },
    { name: "Amsrang Ch Momin", limit: 5 },
    { name: "Brejitha M Sangma", limit: 6 },
    { name: "Shahajuddin Mondol", limit: 4 },
    { name: "Prawin Kumar Jha", limit: 4 },
    { name: "YMM", limit: 4 },
    { name: "HMS", limit: 3 },
    { name: "PRS", limit: 6 },
    { name: "LKS", limit: 4 },
    { name: "PWM", limit: 5 },
    { name: "NI", limit: 5 },
  ];

  // Class names
  const classes = [
    "Nursery",
    "KG",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
  ];

  // Function to initialize the timetable matrix
  const initializeMatrix = () => {
    const periods = 7; // Total periods per day
    const matrix = Array.from({ length: classes.length }, () => Array(periods).fill(null));

    // Track periods assigned to each teacher
    const teacherAssignments = Object.fromEntries(
      teachers.map((teacher) => [teacher.name, 0])
    );

    // Assign fixed teachers for the first period
    for (let i = 0; i < classes.length; i++) {
      const teacher = teachers[i % teachers.length];
      matrix[i][0] = teacher.name; // Fixed teacher for period 1
      teacherAssignments[teacher.name]++;
    }

    // Assign unique teachers for periods 2–7 ensuring no consecutive assignments
    for (let period = 1; period < periods; period++) {
      const usedTeachers = new Set(); // Track assigned teachers for this period
      for (let classIndex = 0; classIndex < classes.length; classIndex++) {
        let availableTeachers = teachers.filter(
          (teacher) =>
            !usedTeachers.has(teacher.name) && // Not already used in this period
            teacherAssignments[teacher.name] < teacher.limit && // Within limit
            teacher.name !== matrix[classIndex][period - 1] // Not the same as the previous period
        );

        if (availableTeachers.length === 0) {
          // Reset available teachers if no options are left (edge case)
          availableTeachers = teachers.filter(
            (teacher) =>
              teacherAssignments[teacher.name] < teacher.limit && // Within limit
              teacher.name !== matrix[classIndex][period - 1]
          );
        }

        if (availableTeachers.length > 0) {
          const randomIndex = Math.floor(Math.random() * availableTeachers.length);
          const selectedTeacher = availableTeachers[randomIndex];
          matrix[classIndex][period] = selectedTeacher.name;
          teacherAssignments[selectedTeacher.name]++;
          usedTeachers.add(selectedTeacher.name);
        }
      }
    }

    return matrix;
  };

  // State for the timetable matrix
  const [matrix, setMatrix] = useState(initializeMatrix);

  // Shuffle function to reassign teachers for periods 2–7
  const shuffleMatrix = () => {
    setMatrix(initializeMatrix());
  };

  return (
    <div style={{ padding: "20px" }}>
      <table border="1" style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th>Classes/Periods</th>
            <th>Period 1 (Fixed)</th>
            {Array.from({ length: 6 }, (_, i) => (
              <th key={i}>Period {i + 2}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {matrix.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td>{classes[rowIndex]}</td>
              {row.map((teacher, colIndex) => (
                <td key={colIndex}>{teacher}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={shuffleMatrix} style={{ marginTop: "20px" }}>
        Shuffle
      </button>
    </div>
  );
};

export default TTMatrix;
